import { supabase } from './supabase'

// Wrapper de supabase.functions.invoke() para Edge Functions que dependen de
// auth.getUser() (todas las sensibles del proyecto). Ante un 401 puntual —
// visto en producción en invitar-por-mail con sesiones recién abiertas,
// sospecha de carrera de rotación de refresh token entre pestañas — se
// intenta un refresh de sesión y UN solo reintento. Mismo shape de retorno
// que invoke() ({ data, error }), así que reemplaza el call site sin tocar
// el manejo de loading/error existente en cada pantalla.
//
// `cliente` es inyectable (default: el singleton de prod) solo para poder
// probar este flujo contra el stack local en un test de integración real,
// sin tocar src/lib/supabase.js — los 6 call sites reales no pasan este
// argumento y se comportan exactamente igual que antes.
export async function invocarFuncion(nombre, opciones, cliente = supabase) {
  const primerIntento = await cliente.functions.invoke(nombre, opciones)
  if (primerIntento.error?.context?.status !== 401) return primerIntento

  console.warn(`[invocarFuncion] 401 en "${nombre}" — reintentando tras refresh de sesión.`)

  const { error: refreshError } = await cliente.auth.refreshSession()
  if (refreshError) return primerIntento

  return cliente.functions.invoke(nombre, opciones)
}
